import React, { useCallback, useEffect, useMemo, useState } from "react";

// Material-UI
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

// Styles
import useStyles from "./style";

import Gap from "../../../components/atoms/Gap";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  Button,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import currency from "../../../utils/currency";
import {
  pencairanCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import {
  FieldValue,
  firefunctions,
} from "../../../components/firebase/FirebaseProvider";
import { Autocomplete } from "@material-ui/lab";
import { getBiayaRegistrasi } from "../../../utils/registrasi";
import { useSnackbar } from "notistack";
import DialogAlertVerifikasi from "./dialogAlertVerifikasi";
import DialogRekening from "../Rekening/dialog";

const AlertModal = ({
  open,
  handleClose,
  totalPencairan,
  feePencairan,
  handleSubmit,
  loading,
}) => {
  const classes = useStyles();

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle style={{ textAlign: "center" }} id="form-dialog-title">
          Konfirmasi
        </DialogTitle>
        <DialogContent dividers>
          <div className={classes.listDialogKomfirm}>
            <div className={classes.listTitle}>Pencairan</div>
            <div className={classes.listSubTitle}>
              {currency(totalPencairan)}
            </div>
          </div>
          <div className={classes.listDialogKomfirm}>
            <div className={classes.listTitle}>Biaya Pencairan</div>
            <div className={classes.listSubTitle}>{currency(feePencairan)}</div>
          </div>
          <Divider
            style={{
              backgroundColor: "black",
              marginLeft: -10,
              marginRight: -10,
            }}
          />
          <div className={classes.listDialogKomfirm}>
            <div className={classes.listTitle}>Total Pencairan</div>
            <div className={classes.listSubTitle}>
              {currency(totalPencairan - feePencairan)}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={handleClose}
            disabled={loading}
          >
            Batal
          </Button>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            Lanjutkan
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

function PencairanDialog({ open, handleClose }) {
  const classes = useStyles();
  const { kredit, profil, bankSeller, global_settings, level, verifikasiData } =
    useData();
  const [transaksi, setTransaksi] = useState(0);
  const [loading, setLoading] = useState(false);
  const total_pencairan_approved = kredit?.total_pencairan_approved ?? 0;
  const { enqueueSnackbar } = useSnackbar();
  const getTotalTransaksiSeller = useCallback(async () => {
    const transaksi = firefunctions.httpsCallable("getTotalTransaksiSeller");
    const res = await transaksi({ user_id: profil.id });
    setTransaksi(res.data);
  });

  useEffect(() => {
    getTotalTransaksiSeller();
  }, []);
  const oneday = 1000 * 60 * 60 * 24;
  const diff = Date.now() - (profil?.created_at?.toMillis?.() ?? Date.now());
  const days_registered = Math.round(diff / oneday);

  let pendingPencaiaran = kredit?.total_pencairan_pending ?? 0;
  const isPending = pendingPencaiaran > 0;
  const isDelay =
    global_settings.aktivasi_delay_pencairan &&
    days_registered <= 30 &&
    transaksi.total_transaksi_sellerapp <= 0;
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    user_id: profil.id,
    tujuan_bank: {},
    total_pencairan: "",
    status: "pending",
    created_at: FieldValue.serverTimestamp(),
  });
  const handleChange = (e) => {
    if (e.target.name == "total_pencairan") {
      const { error, msg } = cekPencairan(e.target.value);
      if (error) {
        return enqueueSnackbar(msg, {
          variant: "error",
        });
      }
    }

    setErrors((errors) => ({ ...errors, [e.target.name]: "" }));
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  // console.log("lol", form);

  const cekPencairan = (toReq) => {
    let saldo = 0,
      pending = 0,
      result = {
        error: false,
        msg: "",
      };
    toReq = toReq.replace(/\./g, "");
    saldo = transaksi.total_saldo_kredit_available
      ? transaksi.total_saldo_kredit_available
      : saldo;

    pending = kredit?.total_pencairan_pending ?? pending;
    if (parseInt(toReq) > saldo) {
      setForm({ ...form, total_pencairan: saldo.toString() });
      setChecked(true);
      result.error = true;
      result.msg =
        "Jumlah permohonan pencairan tidak boleh melebihi total saldo kredit yang dimiliki dan permohonan pencairan yang masih pending";
    }

    if (days_registered <= 30) {
      if (
        saldo === getBiayaRegistrasi(level.level) &&
        transaksi.total_pencairan_approved === 0 &&
        transaksi.total_transaksi_sellerapp <= 0 &&
        global_settings.aktivasi_delay_pencairan
      ) {
        result.error = true;
        result.msg =
          "Mohon maaf kredit dari pendaftaran belum bisa dicairkan, tunggu hingga 30 hari atau lakukan transaksi pembelian produk TokoRame untuk dapat mencairkan!";
      }
    }

    return result;
  };
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const pencairan = parseInt(form?.total_pencairan?.replace(/\./g, ""));

    if (pencairan < transaksi?.total_saldo_kredit_available) {
      setChecked(false);
    }
  }, [form?.total_pencairan, transaksi?.total_saldo_kredit_available]);
  const alertSubmit = () => {
    if (!form.tujuan_bank.nama_bank) {
      enqueueSnackbar("Bank tujuan wajib diisi", {
        variant: "error",
      });
      return;
    }

    if (form.total_pencairan < 15000 || !form.total_pencairan) {
      enqueueSnackbar("Pencairan minimal Rp15.000", {
        variant: "error",
      });
      return;
    }

    setAlertDialog(true);
  };

  const toggleSwicth = (e) => {
    // console.log("lol",e.target.checked);
    if (e.target.checked == false) {
      setForm((oldForm) => ({ ...oldForm, total_pencairan: "" }));
    } else {
      setForm((oldForm) => ({
        ...oldForm,
        total_pencairan: transaksi?.total_saldo_kredit_available.toString(),
      }));
    }
    setChecked(e.target.checked);
  };

  // useEffect(() => {
  //   if (checked === true) {
  //      setForm((oldForm) => ({...oldForm, total_pencairan: transaksi?.total_saldo_kredit_available.toString()}))
  //   }
  // }, [checked, transaksi?.total_saldo_kredit_available]);

  const validate = async () => {
    let newErrors = {};

    if (!form.tujuan_bank) {
      newErrors.tujuan_bank = "Bank tujuan wajib diisi";
    } else if (
      !form.tujuan_bank.id ||
      !form.tujuan_bank.no_rek ||
      !form.tujuan_bank.nama_bank ||
      !form.tujuan_bank.code_bank
    ) {
      newErrors.tujuan_bank = "Terjadi kesalahan";
    }

    if (!form.total_pencairan) {
      newErrors.total_pencairan = "Jumlah pencairan wajib diisi";
    } else {
      const { error, msg } = await cekPencairan(form.total_pencairan);
      if (error) newErrors.total_pencairan = msg;
    }

    return newErrors;
  };

  const feePencairan = (pencairan, level) => {
    if (global_settings.aktivasi_biaya_pencairan) {
      if (level === "mentorbisnis" || level === "distributor") {
        return pencairan < 300000 ? 5000 : 0;
      } else {
        return pencairan < 100000 ? 5000 : 0;
      }
    }
    return 0;
  };

  const handleSubmit = async () => {
    setLoading(true);
    let rawTotalPencairan = parseInt(form?.total_pencairan.replace(/\./g, ""));
    // let pending = kredit?.total_pencairan_pending ?? 0;

    const biaya_pencairan = feePencairan(rawTotalPencairan, level.level);

    const findErrors = await validate();

    if (Object.values(findErrors).some((message) => message !== "")) {
      setErrors(findErrors);
      // setSubmitting(false);
    } else {
      // setSubmitting(true);
      try {
        let data = {
          ...form,
          total_pencairan: rawTotalPencairan - biaya_pencairan,
          biaya_pencairan,
        };
        // console.log(data);
        const res = await pencairanCollection.add(data);
        const postRequestPencairan = firefunctions.httpsCallable(
          "postRequestPencairan"
        );
        await postRequestPencairan({ pencairan_id: res.id });

        enqueueSnackbar("Pengajuan Pencairan sedang diproses!", {
          variant: "success",
        });
        setForm({});
        setAlertDialog(false);
        handleClose();
      } catch (error) {
        console.log(error.message);
        // setSubmitting(false);
      }
    }
    setLoading(false);
  };

  const bank = useMemo(() => [{ nama_bank: "" }, ...bankSeller], [bankSeller]);

  const [alertDialog, setAlertDialog] = useState(false);
  const [alertVerifikasi, setAlertVerifikasi] = useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    data: {},
    mode: "Tambah",
  });

  const handleAlertVerifikasi = () => {
    setAlertVerifikasi(true);
  };

  const handleCloseAlertVerifikasi = () => {
    setAlertVerifikasi(false);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="max-width-dialog-title"
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>Form Perncairan</Typography>
        </div>
      </DialogTitle>
      {/* <Header title="Form Perncairan" type="with-title" onClick={handleClose} /> */}
      <DialogContent dividers style={{ padding: 10 }}>
        <Paper>
          <Gap height={10} />
          <Grid container justify="space-evenly">
            <Grid item className={classes.wrapGrid}>
              <Typography className={classes.liquidPrimary}>
                Kredit Dapat Dicairkan
              </Typography>
              <Typography className={classes.liquidSecond}>
                {currency(transaksi?.total_saldo_kredit_available)}
              </Typography>
            </Grid>
            <Divider />
            <Grid item className={classes.wrapGrid}>
              <Typography className={classes.liquidPrimary}>
                Total Pencairan
              </Typography>
              <Typography className={classes.liquidSecond}>
                {currency(total_pencairan_approved)}
              </Typography>
            </Grid>
          </Grid>
          <Gap height={10} />
        </Paper>
        {isPending ? (
          <>
            <Gap height={10} />
            <Paper style={{ backgroundColor: "#F54C87" }}>
              <Gap height={10} />
              <Typography
                style={{ width: "90%", marginLeft: "5%", color: "white" }}
              >
                Anda memiliki pencairan dengan status pending sebanyak{" "}
                {currency(pendingPencaiaran)}. Mohon menuggu hingga proses
                pencairan tersebut selesai untuk mengajukan pencairan lainnya!
              </Typography>
              <Gap height={10} />
            </Paper>
          </>
        ) : null}
        {isDelay ? (
          <>
            <Gap height={10} />
            <Paper style={{ backgroundColor: "#F54C87" }}>
              <Gap height={10} />
              <Typography
                style={{ width: "90%", marginLeft: "5%", color: "white" }}
              >
                Anda belum melewati masa tunggu 30 hari. Mohon menuggu 30 hari
                atau lakukan transaksi pembelian untuk mengajukan pencairan!
              </Typography>
              <Gap height={10} />
            </Paper>
          </>
        ) : null}
        <Gap height={10} />
        <Paper>
          <Gap height={20} />
          <Autocomplete
            id="tujuan_bank"
            name="tujuan_bank"
            style={{ width: "90%", marginLeft: "5%" }}
            required
            disableClearable
            value={form.tujuan_bank}
            onChange={(event, value) => {
              handleChange({
                target: { name: "tujuan_bank", value },
              });
            }}
            // // disabled={loadingKecamatan || loadingKota || loadingProvinsi}
            options={bank}
            getOptionLabel={(option) => option.nama_bank}
            renderOption={(option) => {
              if (option?.nama_bank) {
                return (
                  <React.Fragment>
                    <div>
                      <Typography className={classes.liquidPrimary}>
                        {option.nama_bank}
                      </Typography>
                      <Typography className={classes.liquidSecond}>
                        {option.no_rek} a.n {option.nama_rek}
                      </Typography>
                      {!option.code_bank ? (
                        <Typography className={classes.liquidErr}>
                          (mohon perbaharui data bank)
                        </Typography>
                      ) : null}
                    </div>
                  </React.Fragment>
                );
              } else {
                return (
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setDialog({ open: true, data: {}, mode: "Tambah" });
                    }}
                    // disabled={isSubmitting}
                    // className={classes.btn}
                  >
                    Tambah Bank
                  </Button>
                );
              }
            }}
            renderInput={(params) => (
              <TextField
                // margin="dense"
                {...params}
                label="Akun Bank Tujuan"
                // InputLabelProps={{ shrink: true }}
                autoFocus
                helperText={errors?.tujuan_bank}
                error={errors?.tujuan_bank ? true : false}
                variant="outlined"
              />
            )}
          />
          <Gap height={20} />
          <Divider />
          <Gap height={20} />
          <FormControlLabel
            control={
              <Switch
                checked={checked}
                // name="total_pencairan"
                // id="total_pencairan"
                color="primary"
                // disabled={true}
                onChange={toggleSwicth}
              />
            }
            style={{ width: "90%", marginLeft: "5%", marginBottom: "15px" }}
            disabled={isPending || isDelay}
            label="Cairkan Semua Kredit Saya"
            // disabled={length === "1" || profil.alamat_utama === id}
          />
          <TextField
            name="total_pencairan"
            label="Jumlah Pencairan"
            // fullWidth
            style={{ width: "90%", marginLeft: "5%", marginBottom: "15px" }}
            placeholder="500.000"
            variant="outlined"
            onChange={handleChange}
            // InputLabelProps={{
            //   shrink: true,
            // }}
            value={form.total_pencairan}
            helperText={errors.total_pencairan}
            error={errors.total_pencairan ? true : false}
            disabled={isPending || isDelay}
            // disabled={isPending}
            type="number"
            // autoComplete="off"
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={
              global_settings.aktivasi_wajib_verifikasi_akun === true
                ? verifikasiData === undefined ||
                  verifikasiData.isRejected === true
                  ? handleAlertVerifikasi
                  : alertSubmit
                : alertSubmit
            }
            style={{ width: "90%", marginLeft: "5%", marginBottom: "15px" }}
            disabled={isPending || isDelay}
            // disabled={isSubmitting}
            // className={classes.btn}
          >
            Ajukan Pencairan Dana
          </Button>
          <Typography
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              width: "90%",
              marginLeft: "5%",
              fontSize: 14,
            }}
          >
            Pencairan dapat dilakukan kapan saja dengan minimal pencairan (Rp
            100.000 atau Rp 300.000 menyesuaikan level), pencairan dengan
            nominal kurang dari batas minimal akan dikenakan biaya penarikan Rp
            5000){" "}
          </Typography>

          <Gap height={20} />
        </Paper>
      </DialogContent>
      <AlertModal
        open={alertDialog}
        handleClose={() => {
          setAlertDialog(false);
        }}
        totalPencairan={form?.total_pencairan?.replace(/\./g, "")}
        feePencairan={feePencairan(
          parseInt(form?.total_pencairan?.replace(/\./g, "")),
          level?.level
        )}
        loading={loading}
        handleSubmit={handleSubmit}
      />
      <DialogRekening
        open={dialog.open}
        data={dialog.data}
        mode={dialog.mode}
        handleClose={() => setDialog({ open: false, data: {}, mode: "Tambah" })}
      />
      {/* <BankDialog
        open={bankDialog}
        handleClose={() => {
          setBankDialog(false);
        }}
      /> */}
      <DialogAlertVerifikasi
        open={alertVerifikasi}
        handleClose={handleCloseAlertVerifikasi}
        verifikasiData={verifikasiData}
        profil={profil}
      />
    </Dialog>
  );
}

export default PencairanDialog;
